import React from "react";
import { Typography } from "@mui/joy";

export const EmptyState: React.FC<{
  tabLabel: string;
  missionStatusLabel?: string;
}> = ({ tabLabel, missionStatusLabel }) => (
  <Typography level="h4" textAlign="center" color="neutral" sx={{ mt: 4 }}>
    Aucun assignment trouvé pour le statut {tabLabel}
    {missionStatusLabel ? ` - ${missionStatusLabel}` : ""}.
  </Typography>
);
